export const MAX_BREADCRUMB_LENGTH = 50;
